import { BC } from 'src/store/ActionTypes';

const INITIAL_STATE = {
  datasetId: undefined,
  datasetName: '',
  segmentId: undefined,
  segmentName: '',
  segmentNames: [],
  modelName: undefined,
  modelNames: [],
  userEmail: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BC.SET_DATASET_ID:
      return {
        ...state,
        datasetId: action.payload,
      };
    case BC.SET_DATASET_NAME:
      return {
        ...state,
        datasetName: action.payload,
      };
    case BC.SET_SEGMENT_ID:
      return {
        ...state,
        segmentId: action.payload,
      };
    case BC.SET_SEGMENT_NAME:
      return {
        ...state,
        segmentName: action.payload,
      };
    case BC.SET_SEGMENT_NAMES:
      return {
        ...state,
        segmentNames: action.payload,
      };
    case BC.SET_MODEL_NAME:
      return {
        ...state,
        modelName: action.payload,
      };
    case BC.SET_MODEL_NAMES:
      return {
        ...state,
        modelNames: action.payload,
      };
    case BC.SET_USER_EMAIL:
      return {
        ...state,
        userEmail: action.payload,
      };
    case BC.RESET:
      return {
        datasetId: undefined,
        datasetName: '',
        segmentId: undefined,
        segmentName: '',
        segmentNames: [],
      };
    default:
      return state;
  }
};
